<template>
  <div class="recipe-preparation">
    <ol v-if="displaySteps.length" class="recipe-preparation__steps">
      <li v-for="(step, index) in displaySteps" :key="index">{{ step }}</li>
    </ol>
    <p v-else class="recipe-preparation__source">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: "RecipePreparation",
  props: {
    steps: { type: Array, default: () => [] },
    text: { type: String, default: "" },
  },
  methods: {
    stripStepNumber(step) {
      return step.replace(/^[ \t]*(?:(?:[ée]tape|step)[ \t]+\d{1,2}(?:[ \t]*[.)/:°\-–—])?|\(\d{1,2}\)|\d{1,2}[ \t]*[.)/:°\-–—])[ \t]*(?=[A-Za-zÀ-ÿ]|\n|$)/gim, (marker, offset, text) => {
        if (/^\s*\d+\s*°\s*$/.test(marker) && /^[CF]\b/.test(text.slice(offset + marker.length))) return marker;
        return "";
      }).trim();
    },
  },
  computed: {
    displaySteps() {
      return this.steps.filter(step => typeof step === "string").map(this.stripStepNumber).filter(step => step.trim());
    },
  },
};
</script>

<style scoped>
.recipe-preparation__steps { margin: 0; padding-left: 1.65em; }
.recipe-preparation__steps li { padding-left: .35em; margin-bottom: 1em; line-height: 1.65; white-space: pre-line; overflow-wrap: anywhere; }
.recipe-preparation__steps li:last-child { margin-bottom: 0; }
.recipe-preparation__steps li::marker { color: #466b22; font-weight: 700; }
.recipe-preparation__source { margin: 0; white-space: pre-line; line-height: 1.65; }
</style>

